/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */

const getTenantUsersBasedOnSearchandFilter = (
  filteredUsers: any[],
  searchText: string
) => {
  const gridDataForTenantUsers = filteredUsers.filter(
    (x: any) =>
      searchText === "" ||
      ((x.firstName &&
        (((x.firstName as string) + " " + x.lastName) as string)) != "" &&
        (((x.firstName as string) + " " + x.lastName) as string)

          .toLowerCase()

          .includes(searchText.toLowerCase().trim()))
  );
  return gridDataForTenantUsers;
};

export default getTenantUsersBasedOnSearchandFilter;
